module.exports = __webpack_public_path__ + "static/media/checklist-blue.87e3eb65.svg";